import { render, staticRenderFns } from "./LawDetail.vue?vue&type=template&id=0a39d365&scoped=true"
import script from "./LawDetail.vue?vue&type=script&lang=js"
export * from "./LawDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a39d365",
  null
  
)

export default component.exports